module.exports = "<div class=\"w3-bottom\" *ngIf=\"showMessages\">\r\n  <ul class=\"w3-ul\">\r\n    <li *ngFor=\"let message of _messagesService.messages\" class=\"w3-text-red\">{{message}}</li>\r\n  </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/messages/messages.component.html
// module id = ./src/app/components/tools/messages/messages.component.html
// module chunks = main